import { useSelector } from 'react-redux';
import { patchOrgAttributes } from '@rsos/sinatra/src/actions/updateAttributes';
import { useCurrentOrg } from '@rsos/sinatra/src/selectors';
import { selectInteragencyChatNotifications } from '@rsos/sinatra/src/selectors/selectInteragencyChatNotifications';
import { CapstoneInteragencyChatNotifications } from '@rsos/sinatra/src/types/Organization';

/**
 * Patches the agency's interagency chat notification settings. The scorpius
 * PATCH deep-merges into the org's existing capstone attributes, but we send the
 * full settings object anyway so a partial update never depends on merge
 * semantics for keys we did not touch.
 *
 * `usePatchAudioSettings` cannot be reused here: it hard-codes the
 * `audio_settings` attribute key, and banner settings are not audio.
 */
export function usePatchInteragencyChatNotifications() {
  const orgId = useCurrentOrg()?.id;
  const currentSettings = useSelector(selectInteragencyChatNotifications);
  return (update: Partial<CapstoneInteragencyChatNotifications>) => {
    if (!orgId) {
      throw new Error(
        'Cannot patch interagency chat notifications without a current organization',
      );
    }
    return patchOrgAttributes(orgId, 'capstone', {
      interagency_chat_notifications: { ...currentSettings, ...update },
    });
  };
}
